import React from "react";
import AliceCarousel from "react-alice-carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";

import Plus from "../../../assets/images/Icons/Links/Plus Circle.svg";

//Style
import "react-alice-carousel/lib/scss/alice-carousel.scss";
import { MDBRow, MDBCol, MDBCard, MDBCardImage } from "mdbreact";

import "./Discover.scss";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

const Discover = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );
  const responsive = {
    0: { items: 1 },
    1024: { items: 4 },
  };
  let Carousel: any;

  return (
    <MDBRow className="discover">
      <MDBCol size={"12"}>
        <div className="link">
          <h5 className="text-right">{state?.discover}</h5>
          <a href="#" className="mr-auto">
            {state?.viewAll}
          </a>
          <hr className="mx-3" />
          <a href="#">
            <img src={Plus} /> <span>{state?.addStory}</span>
          </a>
        </div>
      </MDBCol>
      <MDBCol dir="ltr" className="my-3 relative" size={"12"}>
        <AliceCarousel
          autoPlayDirection={"rtl"}
          autoPlay={true}
          duration={1000}
          responsive={responsive}
          controlsStrategy={"responsive"}
          dotsDisabled={true}
          buttonsDisabled={true}
          ref={(el: any) => (Carousel = el)}
        >
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
          <div className="p-2">
            <MDBCard>
              <MDBCardImage
                className="img-fluid"
                src="https://mdbootstrap.com/img/Photos/Others/images/43.jpg"
                waves
              />
            </MDBCard>
          </div>
        </AliceCarousel>
        <button
          className="alice-carousel-btn prev"
          onClick={() => Carousel.slidePrev()}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
        <button
          className="alice-carousel-btn next"
          onClick={() => Carousel.slideNext()}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>
      </MDBCol>
    </MDBRow>
  );
};

export default Discover;
